import { Card, CardContent } from "@/components/ui/card";
import { TrendingDown, Zap, Users, Heart } from "lucide-react";

const stats = [
  {
    value: "29%",
    color: "text-red-500",
    title: "Increased Heart Disease Risk",
    description: "For every 0.5 percentage-point increase in A1C above 5.0%. Only 1 in 8 American adults have optimal metabolic measures.",
  },
  {
    value: "50%",
    color: "text-green-500",
    title: "Lower Mortality Risk",
    description: "For participants with stronger social relationships. Loneliness is as harmful as smoking 15 cigarettes a day.",
  },
  {
    value: "19%",
    color: "text-blue-500",
    title: "Drop in Mortality Risk",
    description: "For every additional 2.2 pounds of muscle. Those with the most muscle had 50% lower risk of death than those with the least.",
  },
];

const benefits = [
  {
    icon: TrendingDown,
    title: "Reduced Healthcare Costs",
    description: "Lower chronic disease burden translates to lower insurance premiums and claims",
  },
  {
    icon: Zap,
    title: "Increased Productivity",
    description: "Healthier employees mean fewer sick days and higher engagement",
  },
  {
    icon: Users,
    title: "Improved Retention",
    description: "Competitive wellness benefits attract and retain top talent",
  },
  {
    icon: Heart,
    title: "Better Culture & Morale",
    description: "Wellness investments show employees you care about their wellbeing",
  },
];

const HealthBenefits = () => {
  return (
    <section className="py-16 md:py-20 bg-gradient-to-br from-[#0D1B2A]/5 to-[#1B3A4B]/10">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            The Business Case for Metabolic Health
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Investing in employee metabolic health delivers measurable returns across 
            healthcare costs, productivity, and retention.
          </p>
        </div>

        {/* Stats Grid */}
        <div className="grid md:grid-cols-3 gap-6 mb-12">
          {stats.map((stat, index) => (
            <Card key={index} className="text-center hover:shadow-lg transition-shadow border-0 shadow-md">
              <CardContent className="p-6">
                <div className={`text-5xl font-bold ${stat.color} mb-3`}>{stat.value}</div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">{stat.title}</h3>
                <p className="text-sm text-gray-600">{stat.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Benefits Card */}
        <Card className="max-w-4xl mx-auto border-0 shadow-lg">
          <CardContent className="p-8">
            <h3 className="text-xl font-bold text-gray-900 mb-6 text-center">
              What This Means for Your Organization
            </h3>
            <div className="grid sm:grid-cols-2 gap-6">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-[#0D1B2A]/10 flex items-center justify-center">
                    <benefit.icon className="w-5 h-5 text-[#0D1B2A]" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">{benefit.title}</h4>
                    <p className="text-sm text-gray-600">{benefit.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};

export default HealthBenefits;
